export default __webpack_public_path__ + "static/media/b.deca45e5.jpg";